/**
 * Main Layout
 *
 * Standard page layout with Header and Footer
 * Used for most pages (public and authenticated)
 */

import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { DebugToggle } from "../debug";

const MainLayout = ({ children, showFooter = true }) => {
  return (
    <div className="app">
      <Header />
      <main className="container my-5">{children}</main>
      {showFooter && <Footer />}
      <DebugToggle />
    </div>
  );
};

export default MainLayout;
